import { createContext, PropsWithChildren, useContext, useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet';

type SeoContextType = {
  setTitle: (title: string) => void;
};
const SeoContext = createContext<SeoContextType>({} as SeoContextType);
export const SeoProvider = ({ children }: PropsWithChildren) => {
  const [pageTitle, setTitle] = useState<string>('');
  const providerValue = useMemo(() => ({ setTitle }), [setTitle]);

  return (
    <SeoContext.Provider value={providerValue}>
      <Helmet>
        <title>{`Rendered.AI${pageTitle && ` | ${pageTitle}`}`}</title>
        <link
          rel="icon"
          type="image/svg+xml"
          href={process.env.GATSBY_ENV === 'dev' ? '/favicon_purple.svg' : '/favicon_green.svg'}
          sizes="32x32"
        />
      </Helmet>
      {children}
    </SeoContext.Provider>
  );
};
export const useSeo = () => useContext(SeoContext);

export const useSetPageTitle = (title: string) => {
  const { setTitle } = useSeo();
  useEffect(() => {
    setTitle(title);
  }, [setTitle, title]);
};
